import { withLifecycleRules } from './decorators/withLifecycleRules';
export const createResolverRegistry = ({
  httpClient
}) => {
  const env = {
    httpClient
  };
  const registeredResolvers = new Map();
  const register = ({
    entity,
    resolver
  }) => {
    var _registeredResolvers$;
    const existingRegistration = registeredResolvers.get(entity.typeIdentifier);
    if ((existingRegistration === null || existingRegistration === void 0 ? void 0 : existingRegistration.resolver) === resolver) {
      // No-op on duplicate registration
      return existingRegistration;
    }
    const registration = (_registeredResolvers$ = registeredResolvers.get(entity.typeIdentifier)) !== null && _registeredResolvers$ !== void 0 ? _registeredResolvers$ : {
      resolver,
      attachments: new Map()
    };

    // Update the resolver in case it has changed
    registration.resolver = resolver;

    // Update the registration
    registeredResolvers.set(entity.typeIdentifier, registration);
    for (const attachment of [...registration.attachments.values()]) {
      attachment.lifecycle.detach();
      attachment.lifecycle = resolver.attach(attachment.params, attachment.runtime);

      // If there was a request pending, immediately fire a refresh
      if (attachment.runtime.getState().loading) {
        attachment.lifecycle.refresh();
      }
    }
    return registration;
  };
  const getOrRegister = entity => registeredResolvers.get(entity.typeIdentifier) || register({
    entity,
    resolver: entity.defaultResolver
  });
  return {
    register,
    isAttached: ({
      instanceKey,
      entity
    }) => getOrRegister(entity).attachments.has(instanceKey),
    attach: ({
      instanceKey,
      entity,
      params,
      onResolverUpdate,
      getState
    }) => {
      const {
        resolver,
        attachments
      } = getOrRegister(entity);
      const attachment = attachments.get(instanceKey);
      if (attachment) {
        throw Error(`Duplicate attachment for ${entity.originalTypeName}::${instanceKey}`);
      }
      const runtime = {
        next: onResolverUpdate,
        getState,
        env
      };
      attachments.set(instanceKey, {
        params,
        runtime,
        lifecycle: withLifecycleRules(resolver).attach(params, runtime)
      });
    },
    detach: ({
      instanceKey,
      entity
    }) => {
      const {
        attachments
      } = getOrRegister(entity);
      const attachment = attachments.get(instanceKey);
      if (!attachment) {
        throw Error(`Attempting to detach ${entity.originalTypeName}::${instanceKey} but no attachment found`);
      }
      attachment.lifecycle.detach();
      attachments.delete(instanceKey);
    },
    refresh: ({
      instanceKey,
      entity
    }) => {
      const {
        attachments
      } = getOrRegister(entity);
      const attachment = attachments.get(instanceKey);
      if (!attachment) {
        throw Error(`Attempting to refresh ${entity.originalTypeName}::${instanceKey} but no attachment found`);
      }
      attachment.lifecycle.refresh();
    }
  };
};